export type AgentRunStatus =
  | "pending"
  | "running"
  | "completed"
  | "failed"
  | "cancelled";

export class AgentRun {
  constructor(
    public id: string,
    public threadId: string,
    public status: AgentRunStatus,
    public startedAt: Date,
    public completedAt: Date | null,
  ) {}

  /**
   * 実行中かどうか
   */
  get isRunning(): boolean {
    return this.status === "running" || this.status === "pending";
  }

  /**
   * 完了したかどうか
   */
  get isCompleted(): boolean {
    return this.status === "completed";
  }

  /**
   * キャンセル済みかどうか
   */
  get isCancelled(): boolean {
    return this.status === "cancelled";
  }

  /**
   * 失敗したかどうか
   */
  get isFailed(): boolean {
    return this.status === "failed";
  }
}
